/* ------------------------------------------------------------------
   CRANTAIGER — signup source attribution
   Added 2026-09-01.
   Revised 2026-09-08 — wear-test form now also carries van- and pay- tags
   (Field Test Program cohort classification). See ct-waitlist.liquid.
   Revised 2026-09-14 — Homepage Wave 1. Hero form id no longer hard-coded;
   optional occupation <select> on the hero (same eight job-* values).
   Revised 2026-10-02 — Homepage v3.1.0 (Claude Design handoff).
     1. New hero form id ct-home-hero-form added to HERO_FORMS. Same tag
        contract as v3.0: the size <select> is the only element named
        contact[tags]; values unchanged (waitlist,founding-batch-001,size-US-*).
     2. New homepage Field Test form #ct-home-apply-form (wireHomeApply).
        SAME vocabulary as ct-field-test.liquid: weartest, founding-batch-001,
        job-* (8), van-* (4), pay-* (3), size-*, src-*.
        ADDED: waitlist — the homepage copy promises "Not picked this round?
        You stay on the First Access list automatically."
        ADDED: wp-yes / wp-sometimes / wp-no — new family, "Does your job need
        waterproof boots?". Additive only; no existing tag renamed.
        The handoff README proposed first-access / field-test tags. Rejected
        deliberately: renaming would split the November demand-gate counts
        across two vocabularies.

   WHY THIS EXISTS
   Every signup in admin looks identical. In November the demand gate has
   to answer "which channel actually produced this list?" — Reddit, IG,
   direct, or nothing. Without a source tag written at signup time that
   question is unanswerable after the fact.

   HOW
   1. First touch wins. Source read from ?utm_source / ?src / ?ref, or the
      referring hostname, stored once in localStorage.
   2. On submit, the source is appended to contact[tags] as src-<value>.

   FAILURE MODE — DELIBERATE, AND ORDERED
   Every block is wrapped in try/catch and every helper returns early.
     Hero: script blocked -> waitlist + founding-batch-001 + size-US-* still
           land (the select keeps its name). src- lost.
     Apply forms: script blocked -> hidden field default lands
           (weartest,founding-batch-001[,waitlist]). job/van/pay/size/wp/src lost.
   The size tag on the hero is never on the failure path.
   ------------------------------------------------------------------ */
(function () {
  var KEY = 'ct_src';

  /* Hero forms, newest first. All wired so a rollback keeps attribution
     working. Adding a new hero section? Add its id here. */
  var HERO_FORMS = ['ct-home-hero-form', 'ct-hero-v3-form', 'ct-hero-size-form'];

  function clean(v) {
    return String(v)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 24);
  }

  /* --- capture, first touch wins --- */
  try {
    var params = new URLSearchParams(window.location.search);
    var explicit = params.get('utm_source') || params.get('src') || params.get('ref');

    if (explicit) {
      localStorage.setItem(KEY, clean(explicit));
    } else if (!localStorage.getItem(KEY) && document.referrer) {
      var host = new URL(document.referrer).hostname.replace(/^www\./, '');
      if (host && host.indexOf(window.location.hostname) === -1) {
        localStorage.setItem(KEY, clean(host.split('.')[0]));
      }
    }
  } catch (e) {}

  window.ctSource = function () {
    try {
      return localStorage.getItem(KEY) || 'direct';
    } catch (e) {
      return 'direct';
    }
  };

  /* --- hero form: append job- and src- to the <select> value ---
     The size select carries name="contact[tags]" so a no-JS submit still
     records the size. We cannot rewrite select.value (a value with no
     matching <option> submits empty), so we add a hidden field with the
     combined string and only then strip the name off the select. */
  function wireHeroForm(id) {
    var form = document.getElementById(id);
    if (!form || form.dataset.ctWired) return;
    form.dataset.ctWired = '1';

    form.addEventListener('submit', function () {
      try {
        var sel = form.querySelector('select[name="contact[tags]"]');
        if (!sel || !sel.value) return;

        var parts = [sel.value];

        var job = form.querySelector('.cth-job');
        if (job && job.value) parts.push(job.value);

        parts.push('src-' + window.ctSource());

        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'contact[tags]';
        hidden.value = parts.join(',');
        form.appendChild(hidden);
        sel.removeAttribute('name');
      } catch (e) {}
    });
  }

  function wireHero() {
    for (var i = 0; i < HERO_FORMS.length; i++) {
      wireHeroForm(HERO_FORMS[i]);
    }
  }

  /* --- wear-test form (pages/field-test): unchanged since 2026-09-08 --- */
  function wireWearTest() {
    var form = document.getElementById('ct-weartest-form');
    if (!form || form.dataset.ctWired) return;
    form.dataset.ctWired = '1';

    form.addEventListener('submit', function () {
      try {
        var tags = document.getElementById('ct-wt-tags');
        if (!tags) return;

        var job = document.getElementById('ct-wt-job');
        var van = document.getElementById('ct-wt-van');
        var pay = document.getElementById('ct-wt-pay');
        var size = document.getElementById('ct-wt-size');
        var parts = ['weartest', 'founding-batch-001'];

        if (job && job.value) parts.push(job.value);
        if (van && van.value) parts.push(van.value);
        if (pay && pay.value) parts.push(pay.value);
        if (size && size.value) parts.push(size.value);
        parts.push('src-' + window.ctSource());

        tags.value = parts.join(',');
      } catch (e) {}
    });
  }

  /* --- homepage Field Test form (sections/ct-home-apply.liquid) ---
     Selects and radios carry NO contact[...] name. Values are read here by
     class and written into the hidden .ctx-ap-tags field, whose default
     (weartest,waitlist,founding-batch-001) survives a script failure.
     Radio group names (ctx_van / ctx_pay / ctx_wp) exist only so the browser
     can group and validate them; they are removed before the entry list is
     built so nothing but contact[*] is posted. */
  function wireHomeApply() {
    var form = document.getElementById('ct-home-apply-form');
    if (!form || form.dataset.ctWired) return;
    form.dataset.ctWired = '1';

    function radio(name) {
      var r = form.querySelector('input[name="' + name + '"]:checked');
      return r ? r.value : '';
    }

    form.addEventListener('submit', function () {
      try {
        var tags = form.querySelector('.ctx-ap-tags');
        if (!tags) return;

        var parts = ['weartest', 'waitlist', 'founding-batch-001'];
        var job = form.querySelector('.ctx-ap-job');
        var size = form.querySelector('.ctx-ap-size');
        if (job && job.value) parts.push(job.value);
        if (size && size.value) parts.push(size.value);
        var van = radio('ctx_van'); if (van) parts.push(van);
        var pay = radio('ctx_pay'); if (pay) parts.push(pay);
        var wp = radio('ctx_wp'); if (wp) parts.push(wp);
        parts.push('src-' + window.ctSource());

        tags.value = parts.join(',');

        var radios = form.querySelectorAll('input[type="radio"][name^="ctx_"]');
        for (var i = 0; i < radios.length; i++) radios[i].removeAttribute('name');
      } catch (e) {}
    });
  }

  function wire() {
    wireHero();
    wireWearTest();
    wireHomeApply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }

  /* Sections re-render in the theme editor without a page load. */
  document.addEventListener('shopify:section:load', wire);
})();
